import * as types from './actionTypes';
import {ajaxCallError} from './ajaxStatusActions';
import {Api} from '../api/Api';
import {beginAjaxCall} from './ajaxStatusActions';


export function getRegionListSuccess(region) {
  return {type: types.LOAD_REGION_LIST_SUCCESS, region};
}



export function getRegionList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().RegionApi.getRegionList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token).then(region => {                  
                  dispatch(getRegionListSuccess(region));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}



export function getRegionSuccess(catalogo) {
  return {type: types.LOAD_REGION_SUCCESS, catalogo};
}

export function getRegion(id, token) {
    return dispatch => {
        dispatch(beginAjaxCall());  
        return Api().RegionApi.getRegion(id, token).then(region => {   
        dispatch(getRegionSuccess(region));
        return region;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function saveSuccess(region) {
  return {type: types.SAVE_REGION_SUCCESS, region};
}


export function save(region, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().RegionApi.save(region, token).then(regionGuardado => {   
    dispatch(saveSuccess(regionGuardado));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function getRegionComboSuccess(datos) {
  return {type: types.GET_REGIONS_COMBO_SUCCESS, datos};
}

export function getRegionCombo(token) {
    
  return dispatch => {
     
	dispatch(beginAjaxCall());  
      
    return Api().RegionApi.getRegionCombo(token).then(datos => {   
        
      dispatch(getRegionComboSuccess(datos));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

export function getRegionComboByPais(token, paisId) {
    
  return dispatch => {
     
	dispatch(beginAjaxCall());  
      
    return Api().RegionApi.getRegionComboByPais(token, paisId).then(datos => {   
        
      dispatch(getRegionComboSuccess(datos));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

export function borrarSuccess(region) {
  return {type: types.BORRAR_REGION_SUCCESS, region};
}


export function borrar(id, token ) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().RegionApi.borrar(id, token ).then(region => {
               
                  dispatch(borrarSuccess(region));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}




export function activarSuccess(region) {
  return {type: types.ACTIVAR_REGION_SUCCESS, region};
}


export function activar(id, token) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().RegionApi.activar(id, token).then(region => {
               
                  dispatch(activarSuccess(region));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function setFiltro(filtroActivo, filtroActual, showActivos) {
	let filtro={
		filtroActivo,
		filtroActual,
        showActivos
	}
  return {type: types.SET_FILTRO_REGION, filtro};
}



